import type { Theme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    blue: Palette["primary"];
  }

  interface PaletteOptions {
    blue?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    blue: true;
  }
}

export const addBlue = (theme: Theme) =>
  theme.palette.augmentColor({
    color: { main: "#4c6dc3" },
    name: "blue",
  });
